import charts from '../../assets/charts.png'
import { useScreenTracking } from '../../shared-hooks/useScreenTracking'
import { SignupCard } from './SignupCard'

export const InsufficientTripHistory = (): JSX.Element => {
  useScreenTracking(
    'InsufficientTripHistoryView',
    'View insufficient trip history screen'
  )

  return (
    <SignupCard
      iconSrc={charts}
      heading='Your recent driving insights'
      subheading="It looks like you haven't driven much in the past few months. No worries! A specialist on our team will reach out shortly to get you set up."
    />
  )
}
